import { Col, Row } from "react-bootstrap";
import { Control } from "react-hook-form";

import Input from "../../../common/components/form/Input.tsx";
import SearchAddress from "../../../common/components/form/SearchAddress";

export interface DwellingFormFeatureProps {
  control: Control<any>;
}

const BuildingInfoForm = ({ control }: DwellingFormFeatureProps) => {
  return (
    <>
      <Row>
        <Col md={4} className="mt-3 d-flex justify-content-between flex-column">
          <Input
            label={"Nom de la résidence :"}
            control={control}
            name={"address.residenceName"}
          />
        </Col>

        <Col md={2} className="mt-3 d-flex justify-content-between flex-column">
          <Input
            label={"Nombre de bâtiments :"}
            control={control}
            type="number"
            name={"building.buildingNumber"}
          />
        </Col>

        <Col md={2} className="mt-3 d-flex justify-content-between flex-column">
          <Input
            label={"Nombre d’entrées :"}
            control={control}
            type="number"
            name={"building.entryNumber"}
          />
        </Col>

        <Col md={2} className="mt-3 d-flex justify-content-between flex-column">
          <Input
            label={"Nombre de lots :"}
            control={control}
            type="number"
            name={"building.managementLotNumber"}
          />
        </Col>

        <Col md={2} className="mt-3 d-flex justify-content-between flex-column">
          <Input
            label={"Nombre de niveaux :"}
            control={control}
            type="number"
            name={"building.floorNumber"}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col md={12} className="position-relative">
          <SearchAddress
            control={control}
            name={"address"}
            rules={{ required: "veuillez indiquer une adresse" }}
            label="Adresse postale"
            isDisabled={false}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col md={6}>
          <Input
            label={"Complément d’adresse :"}
            control={control}
            name={"address.additionalAddress"}
          />
        </Col>
        <Col md={6}>
          <Input
            label={"Digicode :"}
            control={control}
            name={"address.digicode"}
          />
        </Col>
      </Row>
    </>
  );
};
export default BuildingInfoForm;
